<template>
    <div class="container">
        <h2>Submittal Index</h2>
        <div class="info">
            <p>Products selected for inclusion in this submittal are displayed below.</p>
            <ul>
                <li>Reorder product by dragging and dropping individual rows.</li>
                <li>Hovering over a figure number link will display a picture of the selected product.</li>
                <li>Selecting a datasheet link will display the datasheet of the selected product.</li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['project']
    }
</script>